import { uploadFoodCourtMenuLocal } from 'wasp/client/operations';
import type { FoodCourtMenuMetadata } from './menuTypes';
import { isMenuMimeType } from './menuTypes';
import { MENU_MAX_BYTES } from './menuConstants';

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Failed to read file'));
        return;
      }
      const base64 = result.split(',')[1];
      if (!base64) {
        reject(new Error('Failed to encode file'));
        return;
      }
      resolve(base64);
    };
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsDataURL(file);
  });
}

/** Upload menu via Wasp action (auth handled automatically). */
export async function uploadFoodCourtMenu({
  file,
  locationSlug,
  itemKey,
  contentId,
  setUploadProgressPercent,
}: {
  file: File;
  locationSlug: string;
  itemKey: string;
  contentId?: string;
  setUploadProgressPercent?: (pct: number) => void;
}): Promise<FoodCourtMenuMetadata> {
  if (file.size > MENU_MAX_BYTES) {
    throw new Error(`File must be under ${MENU_MAX_BYTES / 1024 / 1024}MB`);
  }
  if (!isMenuMimeType(file.type)) {
    throw new Error('Menu must be a PDF or image (JPEG, PNG, WebP)');
  }

  setUploadProgressPercent?.(15);
  const fileBase64 = await fileToBase64(file);
  setUploadProgressPercent?.(50);

  const menu = await uploadFoodCourtMenuLocal({
    locationSlug,
    itemKey,
    fileName: file.name,
    fileType: file.type as 'application/pdf' | 'image/jpeg' | 'image/png' | 'image/webp',
    fileBase64,
    contentId,
  });

  setUploadProgressPercent?.(100);
  return menu;
}
